export const HERO_DATA = {
    primaryTitle: "Redefining",
    secondaryTitle: "Real Estate",
    description:
        "Australia’s first AI powered real estate sales platform delivering a faster, more affordable sales process - Sell your home from just $900.",
    searchPlaceholder: "Search by address",
    buttonLabel: "Get Valuation",
    helperText: "Enter your address to get an instant valuation of your home",
} as const;

export const HERO_NOTIFICATIONS_DATA = [
    {
        imageSrc: "/images/avatar.svg",
        alt: "Avatar",
        text: "Offer Received 124 Smith Saint",
        containerClass:
            "gap-1.5 xs:gap-2 sm:gap-2 md:gap-3 items-center p-2 xs:p-2 sm:p-1.5 md:p-1.5 rounded-4xl top-[80%] sm:top-[90%] md:top-[80%] lg:top-[82%] w-[45%] xs:w-[35%] sm:w-[40%] md:w-[50%] lg:w-[55%] left-[4%] lg:left-[6%]",
        textClass: "text-[10px] lg:text-base",
    },
    {
        imageSrc: "/images/avatar.svg",
        alt: "Avatar",
        text: "Offer Received 125 Johnson Avenue",
        containerClass:
            "gap-1.5 xs:gap-2 md:gap-2 items-center p-1.5 xs:p-2 sm:p-2.5 md:p-2 rounded-4xl top-[35%] sm:top-[35%] md:top-[36%] lg:top-[38%] w-[45%] sm:w-[40%] md:w-[55%] lg:w-[55%] left-[8%]",
        textClass: "text-[10px] lg:text-sm xl:text-base",
    },
    {
        imageSrc: "/images/avatar2.svg",
        alt: "Avatar",
        text: "Auction for 126 Brown Boulevard starting now",
        containerClass:
            "gap-1.5 md:gap-2 items-center p-2 rounded-4xl top-[57%] lg:top-[60%] xl:top-[62%] w-[45%] xs:w-[35%] sm:w-[40%] md:w-[70%] lg:w-[55%] right-2 lg:right-4",
        textClass: "text-[10px] lg:text-sm xl:text-base",
    },
] as const;


